/**
 * Stable slug-style fingerprint for an AI observation. Used to deduplicate
 * and match across review runs — even if the LLM rewords the same concern,
 * the fingerprint will be similar enough for exact or near-exact matching.
 *
 * Example:
 *   "Electrical Plan Conflicts With New Appliance Needs"
 *     → "electrical-plan-conflicts-with-new-appliance-needs"
 */
export function observationFingerprint(title: string): string {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80);
}
